import classNames from 'classnames';
import {useNavigate} from 'react-router-dom';

type TFooterItemType = {
  title: string;
  icon?: string;
  router: string;
  isMain?: boolean;
  isActive?: boolean;
};

const FooterItem = ({
  title,
  icon,
  router,
  isMain,
  isActive = false,
}: TFooterItemType) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        className="d-flex flex-column justify-content-end align-items-center h-100 pb-2"
        onClick={() => {
          navigate(router);
        }}
      >
        <i
          className={classNames(
            isActive && 'color-primary',
            'm-auto pt-2 ' + icon,
          )}
        />

        <small className={classNames('fw-800', isActive && 'color-primary')}>
          {title}
        </small>
      </div>
    </>
  );
};

export default FooterItem;
